export const breakpoints = {
  mobile: 0,
  smallTablet: 600,
  tablet: 1023,
  laptop: 1200,
  desktop: 1560,
  large: 2200,
  xLarge: 2600,
};
